import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import charmhealthplaceholder from '../../assets/Loading_4.gif';
import { useNavigate } from "react-router-dom";
import { getVendorId, getVendorProfile, getVendorListings, getVendorOrders, getReviewsByVendor } from '../API_Handler'
import { useUser } from '../../UserContext';
import { useToast } from '../../Common/ToastContext';
import { ConsoleLogger } from 'aws-amplify/utils';

const LoadingVendors = () => {
    const showToast = useToast();
    const navigate = useNavigate();
    const [message, setMessage] = useState('Initializing...');
    const { setUser, setUserStatus, setUserPermissions, setUserListings, setUserOrders, setUserReviews } = useUser(); // Access setUserListings using useUser hook
    const hasLoadedRef = useRef(false); // Prevent multiple executions


    const INTRO_PERMISSIONS = {
        "Dashboard": false,
        "Listings": true,
        "Orders": false,
        "Reviews": false,
        "Users": true
    }

    const NORMAL_PERMISSIONS = {
        "Dashboard": true,
        "Listings": true,
        "Orders": true,
        "Reviews": true,
        "Users": true
    }

    const fetchListings = async () => {
        setMessage('Fetching listings...');
        const userListings = await getVendorListings(showToast);
        setUserListings(userListings);
        return userListings;
    };

    const fetchOrders = async () => {
        setMessage('Fetching orders...');
        const userOrders = await getVendorOrders(showToast);
        setUserOrders(userOrders);
        return userOrders;
    };

    const fetchReviews = async () => {
        setMessage('Fetching reviews...');
        const userReviews = await getReviewsByVendor(showToast);
        setUserReviews(userReviews);
        return userReviews;
    };

    useEffect(() => {
        // Prevent multiple executions
        if (hasLoadedRef.current) return;
        hasLoadedRef.current = true;

        const loadData = async () => {
            const vendorId = await getVendorId(showToast);
            if (!vendorId) {
                navigate('/vendors/login');
                return;
            }


            const vendorProfile = await getVendorProfile();
            if (!vendorProfile) {
                navigate('/vendors/error');
                return;
            }

            setUser(vendorProfile);
            //Can be "APPROVED", "PENDING", "REJECTED"
            setUserStatus(vendorProfile['approval_status']);

            if (vendorProfile['is_active'] === false) {
                navigate('/vendors/deactivated');
                return;
            }
            else if (vendorProfile['approval_status'] === "PENDING") {
                navigate('/vendors/unapproved');
                return;
            }
            else if (vendorProfile['approval_status'] === "REJECTED") {
                navigate('/vendors/rejected');
                return;
            } else {
                setUserPermissions(NORMAL_PERMISSIONS);
                await fetchListings();
                await fetchOrders();
                await fetchReviews();
                setMessage('Taking you to your dashboard...');
                navigate('/vendors/profile/dashboard');
            }

        };
        loadData();
    }, []);

    return (
        <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 bg-light">
            <img src={charmhealthplaceholder} alt="Charm Health" className="mb-4 w-[3rem]" />
            <p className="mb-4 text-md" style={{ color: 'gray' }}>{message}</p>
        </div>
    );
};

export default LoadingVendors;
